export enum WindowSize {
  xxxs = 'xxxs',
  xxs = 'xxs',
  xs = 'xs',
  s = 's',
  m = 'm',
  xm = 'xm',
  l = 'l'
}

export const mapSizeToLimit = {
  [WindowSize.xxxs]: 0,
  [WindowSize.xxs]: 500,
  [WindowSize.xs]: 768,
  [WindowSize.s]: 1280,
  [WindowSize.m]: 1440,
  [WindowSize.xm]: 1600,
  [WindowSize.l]: 1920
};

export const windowSizesOrder = [
  WindowSize.xxxs,
  WindowSize.xxs,
  WindowSize.xs,
  WindowSize.s,
  WindowSize.m,
  WindowSize.xm,
  WindowSize.l
];
